import { z } from 'zod'

import { InventoryHoldStatus } from '../constants/inventoryHold'
import { dbEntitySchema } from './system'

export const inventoryHoldSchema = dbEntitySchema.extend({
  user: z.string().nullish(),
  prospect: z.string().nullish(),
  confirmationRequest: z.string().nullish(),
  venue: z.string(),
  inventory: z.string(),
  date: z.date(),
  level: z.string().nullish(),
  orderCart: z.string().nullish(),
  quantity: z.number().int().min(1),
  expiresAt: z.date(),
  status: z.nativeEnum(InventoryHoldStatus),
  releasedAt: z.date().nullish(),
})
